import React from "react";
import { LoginContainer } from "modules";

type Props = {};

const Login = (props: Props) => {
  return <LoginContainer />;
};

export default Login;
